export default "__VITE_ASSET__Sb4NjsNR__"